import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import category from "../../data/category";
import { useHistory } from "react-router-dom";
import PageNation from "../../components/organisms/pagination";
import { inject, observer } from "mobx-react";
import moment from "moment-timezone";

const Board = inject("commonStore")(
  observer((props) => {
    const history = useHistory();
    const twRef = useRef(); //작성자,제목 검색 ref
    const stateRef = useRef(); //진행도 ref
    const goDetail = (id) => {
      //칼럼 상세보기
      history.push(`/detail/${id}`);
    };
    const [notice, setNotice] = useState([]);
    const searchRef = useRef(); //검색 ref
    useEffect(() => {
      props.commonStore
        .getAllList() // 공지사항 게시물
        .then((res) => {
          setNotice(res.filter((v) => v.main_keyword.includes("공지사항")));
        });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const searchHandler = () => {
      // 검색하기 버튼 클릭시 동작
      props.commonStore.searchWord(searchRef.current.value, twRef.current.value, parseInt(stateRef.current.value));
    };
    const pressEnter = () => {
      if (window.event.keyCode === 13) {
        searchHandler();
      }
    };

    // 이전 검색어 저장을 위한 session storage 저장 코드
    useEffect(() => {
      const savedSearchKeyword = sessionStorage.getItem("searchKeyword");
      if (savedSearchKeyword && searchRef.current) {
        searchRef.current.value = savedSearchKeyword;
      }
    }, []);

    useEffect(() => {
      console.log("검색어:", searchRef.current.value);
      if (searchRef.current) {
        sessionStorage.setItem("searchKeyword", searchRef.current.value);
      }
    }, [searchRef.current?.value]);

    return (
      <Box>
        <div>
          <select className="selection" ref={twRef}>
            <option>제목</option>
            <option>작성자</option>
          </select>
          <div className="search_box">
            <input type="text" placeholder="검색어를 검색하세요." ref={searchRef} onKeyUp={pressEnter} />
            <img src={require("../../styles/img/search.png")} onClick={searchHandler} alt={"돋보기"} />
          </div>
          <select className="selection" ref={stateRef}>
            <option value={0}>전체</option>
            <option value={1}>임시저장</option>
            <option value={2}>검수전</option>
            <option value={3}>반려</option>
            <option value={4}>검수완료</option>
            <option value={5}>업로드완료</option>
          </select>
          <div onClick={() => history.push("/compose")}>글 작성하기</div>
        </div>
        <div className="box">
          <div>
            <div>
              {notice.map((v) => {
                return (
                  <div key={v.id}>
                    <span>
                      <span role="img" aria-label="">
                        📢
                      </span>
                      <span> 공지</span>
                    </span>
                    <span onClick={() => goDetail(v.id)}>{v.title}</span>
                  </div>
                );
              })}
            </div>
            <div className="cate">
              {category.map((v) => {
                return (
                  <span key={v.id} style={{ width: v.width }}>
                    {v.cont}
                  </span>
                );
              })}
            </div>
            <div className="list_box">
              {props.commonStore.page.map((v) => {
                return (
                  <>
                    <div key={v.id} className="list" onClick={() => goDetail(v.id)}>
                      <span style={{ width: "8.25%" }}>{v.id}</span>
                      <span style={{ width: "13.75%", color: "#A5A4BF" }}>
                        {v.category}/{v.sub_category}
                      </span>
                      <span style={{ width: "33.5%" }}>{v.title}</span>
                      <span style={{ width: "10.5%" }}>{v.writer}</span>
                      <span style={{ width: "19%", color: "#B0AFC7" }}>{moment(v.createDate).tz("Asia/Seoul").format("YYYY/MM/DD HH:mm")}</span>
                      <span style={{ width: "15%" }}>
                        {/* <span>{v.state}</span> */}
                        {v.state === 1 ? (
                          <div>임시저장</div>
                        ) : v.state === 2 ? (
                          <div style={{ color: "#636363", border: "1px solid #636363" }}>검수전</div>
                        ) : v.state === 3 ? (
                          <div className="red">반려</div>
                        ) : v.state === 4 ? (
                          <div className="red" style={{ background: "#B8B7F0" }}>
                            검수완료
                          </div>
                        ) : (
                          <div className="red" style={{ background: "#3B86FF" }}>
                            업로드완료
                          </div>
                        )}
                      </span>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
          <PageNation lengths={props.lengths} />
        </div>
      </Box>
    );
  })
);

const Box = styled.div`
  margin-top: -25px;
  > div:first-child {
    display: flex;
    justify-content: flex-end;

    > .search_box,
    > .selection {
      background: white;
      box-sizing: border-box;
      padding: 10px;
      display: flex;
      align-items: center;
      border: 1px solid #d2d3d6;
      border-radius: 4px;
      margin: 0 2.5px;

      > input {
        all: unset;
        font-size: 12px;
      }

      > img {
        width: 20px;
        cursor: pointer;
      }
    }

    > .selection {
      font-size: 12px;
      padding-left: 5px;
    }

    > div:last-child {
      background: #3b86ff;
      color: white;
      margin-left: 5px;
      box-sizing: border-box;
      padding: 10px 20px;
      border-radius: 4px;
      font-size: 14px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
  }

  > div:last-child {
    margin-top: 10px;
    height: 760px;
    align-items: flex-start !important;
    flex-direction: column;

    > div:first-child {
      width: 100%;
      height: 90%;
      > div:first-child {
        border: 2px solid #d3d1cb;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 10px;

        > div {
          border-bottom: 1px solid #edece9;
          padding: 10px 0;

          > span:first-child {
            margin-right: 40px;
          }

          > span:last-child {
            font-weight: bold;
            cursor: pointer;
          }
        }

        > div:last-child {
          border-bottom: none;
        }
      }
      > .cate {
        width: 100%;
        display: flex;
        justify-content: space-between;
        height: 30px;
        align-items: center;
        background: #f5f6fa;
        margin-top: 10px;

        > span {
          text-align: center;
          font-weight: bold;
        }
      }

      > .list_box {
        width: 100%;

        > .list {
          display: flex;
          justify-content: flex-start;
          border-bottom: 1px solid #dbdbdb;
          align-items: center;
          height: 36px;
          font-size: 13px;
          cursor: pointer;

          > span {
            text-align: center;
          }

          > span:nth-child(3) {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1; /* 라인수 */
            -webkit-box-orient: vertical;
          }

          > span:last-child {
            display: flex;
            justify-content: center;

            > div {
              width: 100px;
              border: 1px solid #b1b1b1;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 25px;
              border-radius: 4px;
              color: #959595;
            }

            > .red {
              background: #ed4c19;
              color: white;
              border: none;
            }
          }
        }
      }
    }
  }
`;

export default Board;
